import { Auth } from "aws-amplify";
import { isAmplifyConfigExists } from "api/ssoHelper";
import { getAdfenixToken } from "utils/authHelpers";

export const getIdToken = async (tokenOptional = false) => {
  try {
    if (isAmplifyConfigExists()) {
      const loggedInUser = await Auth.currentAuthenticatedUser();

      if (loggedInUser) {
        const user = loggedInUser?.getSignInUserSession();
        const idToken = user?.getIdToken();

        return idToken.getJwtToken() as string;
      }
    } else {
      throw "Amplify config not exist!";
    }
  } catch {
    const adfenixToken = getAdfenixToken();

    if (adfenixToken) {
      return adfenixToken;
    } else if (!tokenOptional) {
      console.info(`No token found! ${window.location.search}`);
    }
  }
};
